import { Opportunity } from "@/opportunity/opportunity";
import React from "react";
import { Card } from "@/components/ui/card";
import { OpportunityEditableField } from "@/opportunity/opportunity_detail_page/OpportunityEditableField";

const OpportunityNotesCard = ({ 
  opportunity,
  showStaffView = true, // Default to true for backward compatibility
}: { 
  opportunity: Opportunity;
  showStaffView?: boolean;
}) => (
  <Card className="p-4">
    <OpportunityEditableField
      header="Notes (Internal)"
      opportunity={opportunity}
      opportunityKey="reviewer_notes_internal"
      noValueMessage="No notes available."
      showStaffView={showStaffView}
    />
  </Card>
)

export default OpportunityNotesCard;
